// @flow
import v4 from 'uuid/v4';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdAdd } from 'react-icons/lib/md';

import * as selectors from '../../reducers';
import RelationSearchPopover from './RelationSearchPopover';
import RelationListDisplay from './RelationListDisplay';
import styles from './relationGridInput.css';
import type { PARENT_TYPE } from '../../types/parents';
import { ReduxClickPopover } from '../Closeable';
import Button from '../Button';


type RelationGridInputPropTypes = {
  onChange: Function,
  value: Array<PARENT_TYPE>,
};

const RelationGridInputComponent = ({
  onChange,
  value,
}: RelationGridInputPropTypes) => {
  return (
    <div className={styles.relationGridInput}>
      <div className={styles.relationGridTitle}>
        <h3 className={styles.relationGridTitleText}>Contactos del Estudiante</h3>
        <ReduxClickPopover
          isInline
          id="add-parents"
          Content={RelationSearchPopover}
          className={styles.visible}
          onChange={onChange}
          relations={value}
          vertical="above"
          horizontal="center"
          tipPosition="center"
          isRound="true"
        >
          <Button
            size="small"
            tint="secondary"
            title="Contacto"
            Icon={MdAdd}
            clearMargins
          />
        </ReduxClickPopover>
      </div>
      <RelationListDisplay
        relations={value}
        onChange={onChange}
      />
    </div>
  );
}

const RelationGridInput = connect(
  (state, { id }) => ({
    id,
    isShowingStopsDetail: selectors.isRouteWatchingStops(state, id),
    currentRoute: selectors.getCurrentRoute(state),
  }),
  undefined,
)(RelationGridInputComponent);


export default RelationGridInput;



// WEBPACK FOOTER //
// ./src/scripts/components/RelationGridInput/index.jsx